import { type NewStory, type TypeStoryOrientation } from 'types/api/story'

export function formatStory(story: any) {
  const formatedStory: NewStory = {}

  if (story.image?.id) {
    formatedStory.photo_id = story.image.id
  } else if (story.video) {
    formatedStory.videos = [
      ...story.video.map(
        (video: {
          id?: string
          path?: string
          orientation: TypeStoryOrientation
          s3_path?: string
          duration?: number
          video_exif?: any
        }) => ({
          id: video.id,
          orientation: video.orientation,
          path: video.path ?? '',
          duration: video.duration,
          video_exif: video.video_exif,
        })
      ),
    ]
  } else if (story.background) {
    formatedStory.background_color = story.background
  }

  if (story.textValue) {
    formatedStory.text = {
      value: story.textValue,
      x: story.textPosition[0],
      y: story.textPosition[1],
    }
  }

  if (story.pollData) {
    formatedStory.poll = {
      type: story.pollData.type,
      question: story.pollData.question,
      answers:
        story.pollData.answers?.filter(
          (answer: string) => answer
        ) ?? null,
    }
  }

  if (story.scheduleDate) {
    formatedStory.schedule_date = story.scheduleDate
    formatedStory.schedule_timezone =
      story.scheduleTimezone ??
      Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  return formatedStory
}